let UICompat

export function getUICompat () {
  if (UICompat) return UICompat

  const TinperM = window.TinperM
  const TinperNext = window.TinperNext

  let Skeleton
  let Progress
  let Spin
  let Icon
  let Tooltip
  let Modal
  let Input
  let multilangComponents

  if (TinperM) {
    Progress = TinperM.ProgressBar
    Skeleton = function Skeleton (props) {
      return (
        <TinperM.Skeleton.Paragraph {...props}></TinperM.Skeleton.Paragraph>
      )
    }
    Spin = function Spin (props) {
      return (
        <TinperM.Loading type='toast' show={props.spinning} content={lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6004500004', '加载中')} />
      )
    }
  } else if (TinperNext) {
    const { ConfigProvider } = TinperNext
    multilangComponents = [TinperNext.Modal, TinperNext.Input, TinperNext.Progress, TinperNext.Spin, TinperNext.Icon, TinperNext.Tooltip].map((Component) => {
      return (props) => {
        return (
          <ConfigProvider locale={window.lang?.getLanguage()}>
            <Component {...props}/>
          </ConfigProvider>
        )
      }
    })
    Skeleton = function Skeleton () {
      return (
        <TinperNext.Skeleton active></TinperNext.Skeleton>
      )
    }
  }

  UICompat = multilangComponents ? {
    Skeleton,
    Modal: multilangComponents[0],
    Input: multilangComponents[1],
    Progress: multilangComponents[2],
    Spin: multilangComponents[3],
    Icon: multilangComponents[4],
    Tooltip: multilangComponents[5]
  } : {
    Input,
    Modal,
    Skeleton,
    Spin,
    Progress,
    Tooltip,
    Icon
  }

  return UICompat
}
